
import { Droplet, Factory, FlaskConical, Globe, Leaf, Recycle, ShieldCheck, Users, Wind, Trash2 } from "lucide-react";

export const companyDetails = {
  name: "BG TECHNO CHEM",
  tagline: "28+ Years of Water Treatment Excellence",
  motto: "SAVE WATER, SAVE ENERGY, SAVE MOTHER EARTH",
  certifications: "ISO 9001:2015 & (EMS) ISO 14001:2015 Certified Company",
  welcomeText: "We offer environmental consultancy and biotechnological solutions at cost-effective rates. Situated in Ludhiana, we are one of the well-liked companies engaged in offering water treatment plants, effluent treatment plants, sewage treatment plants, solid waste management, and air pollution control systems. Incepted in the year 2000 by enthusiastic persons aimed to make the environment absolutely free from various types of pollutants.",
  location: "S.C.O. 26, 27, 28, Bank Colony Road, Jamalpur Chowk, Ludhiana - 141015, Punjab, India",
  experience: "28+",
  phone: "+91 98142 04405",
  email: "bgtechnochem2000@gmail.com",
  socials: {
    linkedin: "https://linkedin.com",
    instagram: "https://instagram.com",
    whatsapp: "https://wa.me/919814204405"
  }
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
  { name: "About Us", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Industries", path: "/industries" },
  { name: "Contact", path: "/contact" }
];

export const services = [
  {
    id: 1,
    title: "Sewage Treatment Plants (STP)",
    shortDesc: "Advanced biological and biotechnological treatment solutions for domestic wastewater.",
    longDesc: "Our Sewage Treatment Plants utilise cutting-edge aerobic and anaerobic technologies to treat wastewater effectively. We ensure compliance with pollution control board norms while maximizing water recovery for gardening and flushing.",
    icon: Recycle,
    image: "https://images.unsplash.com/photo-1533077162801-86490c593afb" 
  },
  {
    id: 2,
    title: "Effluent Treatment Plants (ETP)",
    shortDesc: "Industrial grade treatment for complex chemical and biological effluents.",
    longDesc: "Designed for tough industrial effluents, our ETPs handle high COD/BOD loads, heavy metals, and toxic substances. Perfect for textile, pharma, and chemical industries.",
    icon: Factory,
    image: "https://images.unsplash.com/photo-1705708551758-76b153fa536e"
  },
  {
    id: 3,
    title: "Water Treatment Plants (WTP)",
    shortDesc: "Purification systems for potable and industrial process water.",
    longDesc: "From RO plants to Softeners and DM plants, we provide comprehensive water purification solutions ensuring the highest quality water for your boiler, cooling tower, or drinking needs.",
    icon: Droplet,
    image: "https://images.unsplash.com/photo-1705147219565-fe9f6f369d03"
  },
  {
    id: 4,
    title: "Solid Waste Management",
    shortDesc: "Eco-friendly disposal and recycling solutions for industrial waste.",
    longDesc: "Comprehensive solid waste management systems designed to segregate, recycle, and dispose of industrial waste responsibly, keeping the environment free from pollutants.",
    icon: Trash2,
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b"
  },
  {
    id: 5,
    title: "Air Pollution Control",
    shortDesc: "Systems to monitor and control industrial emissions and pollutants.",
    longDesc: "Advanced air pollution control devices designed to filter harmful particulates and gases, ensuring your facility meets all environmental air quality standards.",
    icon: Wind,
    image: "https://customer-assets.emergentagent.com/job_cleanwater-tech-1/artifacts/mj0qdb87_Air%20Pollution.jpeg"
  },
  {
    id: 6,
    title: "Chemicals & Consumables",
    shortDesc: "Premium quality chemicals for ongoing plant maintenance.",
    longDesc: "We supply high-grade coagulants, flocculants, antiscalants, and pH boosters. Our chemicals are formulated to enhance plant performance and extend equipment life.",
    icon: FlaskConical,
    image: "https://images.pexels.com/photos/5428266/pexels-photo-5428266.jpeg"
  }
];

export const industries = [
  { name: "Manufacturing", icon: Factory },
  { name: "Textile", icon: Droplet },
  { name: "Pharmaceuticals", icon: FlaskConical },
  { name: "Food & Beverage", icon: Leaf },
  { name: "Commercial Complexes", icon: Users },
  { name: "Municipal", icon: Globe },
];

export const stats = [
  { label: "Years Experience", value: "28+" },
  { label: "Projects Completed", value: "500+" },
  { label: "Happy Clients", value: "300+" },
  { label: "States Covered", value: "12+" },
];
